import { Comments } from './components';
import React from 'react';
import MarketWinLow from 'components/MarketWinLow';
import FearGreedIndex from 'components/FearGreedIndex';
import 'assets/css/wall.css';
import 'assets/css/comment.css';

const Comment = () => (
    <div className="wall-page comment-page">
        <div className="wall-row">
            <Comments />
            <div className="wall-side">
                <FearGreedIndex />
                <MarketWinLow />
            </div>
        </div>
    </div>
);

export default Comment;
